import type {
  RouteObject,
  LoaderFunction,
  ActionFunction,
  ClientLoaderFunction,
  ClientActionFunction,
  LazyRouteFunction,
} from 'react-router';
import type { ComponentType } from 'react';

export interface RouteModule {
  default: ComponentType;
  loader?: LoaderFunction | ClientLoaderFunction;
  action?: ActionFunction | ClientActionFunction;
  ErrorBoundary?: ComponentType;
}

function createLazyRoute(
  moduleImport: () => Promise<RouteModule>
): LazyRouteFunction<RouteObject> {
  return async () => {
    const module = await moduleImport();
    return {
      Component: module.default,
      loader: module.loader as LoaderFunction,
      action: module.action as ActionFunction,
      ErrorBoundary: module.ErrorBoundary,
    };
  };
}

export function route(
  path: string,
  moduleImport: () => Promise<RouteModule>
): RouteObject {
  return {
    path,
    lazy: createLazyRoute(moduleImport),
  };
}

export function index(moduleImport: () => Promise<RouteModule>): RouteObject {
  return {
    index: true,
    lazy: createLazyRoute(moduleImport),
  };
}

export function layout(
  moduleImport: () => Promise<RouteModule>,
  children: RouteObject[]
): RouteObject {
  return {
    children,
    lazy: createLazyRoute(moduleImport),
  };
}

export function prefix(pathPrefix: string, routes: RouteObject[]): RouteObject {
  return {
    path: pathPrefix,
    children: routes,
  };
}
